import { RootState } from '..';
import {RulesState} from './types';
import {createSelector} from "reselect";


export const rootSelector: (state: RootState) => RulesState = (state: RootState) => state.rules;

export const rulesSelector = createSelector(rootSelector, (items) => items.rules);
